<template>
  <main-logo-register class="logo__main" />

  <div>
    <section class="container">
      <div class="container__info">
        <span class="name">
          {{ 
            [ClientStatus.Expired, ClientStatus.Actived].includes(Number(state)) ?
            `Tu enlace ha caducado el ${formatDate(dateExpired)}` :
            state == ClientStatus.Canceled ?
            'Este enlace ya no está disponible' :
            'Enlace inválido'
          }}
          <!-- ¡Ups! Tu Token ha vencido -->
        </span>
      </div>
      <div class="information">
        <p class="info" v-if="[ClientStatus.Expired, ClientStatus.Actived].includes(Number(state))">
          El enlace generado ya no se encuentra disponible porque ha pasado su <br/>
          vigencia de {{ hours }} horas. <br/>
          Comunícate con uno de nuestros asesores para brindarte más <br/>
          información sobre como proceder.
        </p>
        <p class="info" v-else-if="state == ClientStatus.Canceled">
          El enlace generado fue cancelado y ya no se encuentra disponible. <br/>
          Comunícate con uno de nuestros asesores para conocer más <br/>
          información.
        </p>
        <p class="info" v-else>
          Comunícate con uno de nuestros asesores para brindarte más <br/>
          información sobre como proceder.
        </p>
      </div>
      <div class="separator"></div>
    </section>
    <section class="drawing">
      <img src="@/app/register/assets/padlock.png" alt="padlock" />
    </section>
  </div>
</template>

<script>
import { defineComponent } from "vue";

import { useValidateWorkspace } from "@/app/auth/composables/useValidateWorkspace";

import MainLogoRegister from "@/app/shared/components/molecules/MainLogoRegister.vue";
import { ClientStatus } from "@/app/common/types";
import dayjs from "dayjs";

export default defineComponent({
  components: {
    MainLogoRegister,
  },
  computed: {
    state() {
      return this.$route.query.state;
    },
    dateExpired() {
      return this.$route.query.date;
    },
    hours() {
      return this.$route.query.hours;
    }
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format("DD/MM/YYYY");
    }
  },
  data() {
    return {
      loading: false,
      password: "",
      workspace: "",
      ClientStatus,
    };
  },
});
</script>

<style lang="sass" scoped>


.container
  text-align: center

.drawing
  margin-top: 50px
  text-align: center

.container__info
  margin: 0 auto
  margin-top: 90px
  text-align: center
  margin-bottom: 20px

.name
  font-weight: 600
  font-size: 30px

.separator
  margin-bottom: 30px

.button
  width: 100%

.information
  font-size: 20px
  color: $gray-9

.logo__main
  background-color: $white
  padding: 12px 0 0
  margin-top: -20px

.background
  background-color: $background-main

.info
  margin: 0

.team
  margin-top: 30px
</style>
